/**
 * <bm-affected-biz-events affected="list" when="saving" note-class="swe-changes-note">
 *
 * Tells which business event versions an API collection edit recomputes —
 * the ones using a changed operation, as resolved by the swagger validate
 * endpoint (affected_biz_events). `affected` null means it couldn't be
 * determined: falls back to the generic notice. `note-class` is the host
 * dialog's own note style, so it matches the surrounding design.
 */
angular.module('bizmetryApp').component('bmAffectedBizEvents', {
  bindings: {
    affected: '<',
    when: '@',
    noteClass: '@'
  },
  template: `
    <div class="{{ $ctrl.noteClass }}" ng-style="$ctrl.isNone() ? $ctrl.NONE_STYLE : null">
      <md-icon ng-style="$ctrl.isNone() ? { color: 'var(--bm-text-muted)' } : null">
        {{ $ctrl.isNone() ? 'info' : 'autorenew' }}
      </md-icon>
      <div style="min-width:0;">
        <span ng-if="$ctrl.affected == null">
          Business Events using these operations are recomputed after {{ $ctrl.when }}.
        </span>
        <span ng-if="$ctrl.isNone()">
          No Business Event uses the changed operations — nothing to recompute.
        </span>
        <span ng-if="$ctrl.affected.length">
          Recomputed after {{ $ctrl.when }}:
        </span>
        <ul ng-if="$ctrl.affected.length" style="margin:4px 0 0;padding-left:16px;">
          <li ng-repeat="a in $ctrl.affected track by $index" style="margin:2px 0;overflow-wrap:anywhere;">
            <b>{{ a.name }}</b> v{{ a.version }}
            <bm-status-badge status="a.status"></bm-status-badge>
            <span style="font-family:var(--bm-font-mono);font-size:11px;"> · {{ a.operations.join(', ') }}</span>
          </li>
        </ul>
      </div>
    </div>
  `,
  controller: function () {
    var ctrl = this;
    ctrl.NONE_STYLE = { background: 'var(--bm-surface-2)', 'border-color': 'var(--bm-border)' };
    ctrl.isNone = function () {
      return Array.isArray(ctrl.affected) && ctrl.affected.length === 0;
    };
  }
});
